module.exports = __webpack_public_path__ + "6b87425d8e7a584b99276a022bb9d8af.svg";